import React from 'react';
import PropTypes from 'prop-types';
import Parallax from 'parallax-js';
import YouTube from 'react-youtube';
import Octicon from 'react-octicon';
import UAParser from 'ua-parser-js';

import Mouse from '../../components/Mouse';
import ManBlock from './ManBlock';
import HandBlock from './HandBlock';
import LineBlock from './LineBlock';

import send from '../../utils';

import './video-block.css';

const uaParser = new UAParser();
const browser = uaParser.getResult();
const isWebkit = browser.browser.name === 'WebKit';

const screen = {
  w414: { width: 355, height: 200 },
  w375: { width: 305, height: 200 },
  w320: { width: 255, height: 200 },
};

let size = screen[`w${window.screen.width}`];

if (!size) size = { width: 480, height: 280 };

const initVideos = [
  {
    id: '01',
    story: '飛常禁忌',
    description: '這位空姐，這樣毀了一生？',
    youtubeID: 'RQTkCSBvJRY',
    dr: '李懿軒',
    hideLink: true,
  },
  {
    id: '02',
    story: '肝怨傳說',
    description: '很多人自殘，自己卻不自知？',
    youtubeID: 'NCJkw1ksUgo',
    dr: '潘志遠',
    hideLink: true,
  },
  {
    id: '03',
    story: '藥命效應',
    description: '聽說想找死，這樣做最沒救？',
    youtubeID: 'D1scO3ylCaw',
    dr: '潘志遠',
    hideLink: true,
  },
];

class VideoBlock extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      videos: initVideos,
      videoIndex: 0,
    };
  }

  componentDidMount() {
    new Parallax(this.block);
  }

  shouldComponentUpdate() {
    if (!this.props.isShow) {
      this.setState({
        videos: initVideos,
      });
    }
    return true;
  }

  handleClick = (videoIndex) => {
    if (videoIndex < 0) videoIndex = 2;
    videoIndex %= 3;

    this.setState({
      videoIndex,
      videos: initVideos,
    });
  }

  handleHideLink = () => {
    const { videos, videoIndex } = this.state;
    const video = videos[videoIndex];
    this.setState({
      videos: [
        ...videos.slice(0, videoIndex),
        { ...video, hideLink: false },
        ...videos.slice(videoIndex + 1)
      ]
    });
  }

  render() {
    const { videos, videoIndex } = this.state;
    const video = videos[videoIndex];
    return (
      <div className={`block video ${this.props.isShow && 'show'} ${isWebkit && 'webkit'}`}>
        <div className="cloud-block" ref={(block) => { this.block = block; }}>
          <div data-depth="0.20"><div className="cloud cloud-6-copy-4" /></div>
          <div data-depth="0.40"><div className="cloud cloud-6-copy-3" /></div>
          <div data-depth="0.30"><div className="cloud cloud-6-copy-2" /></div>
          <div data-depth="0.40"><div className="cloud cloud-6-copy" /></div>
          <div data-depth="1.00"><div className="cloud cloud-12" /></div>
        </div>
        <div className="container">
          <div className="video">
            <div
              className={`screen-bg ${video.hideLink && 'hide'}`}
              style={{
                width: size.width,
                height: size.height,
              }}
            >
              <a href="https://www.google.com.tw/search?q=%E6%AD%A2%E7%97%9B%E8%97%A5+%E6%AE%98%E7%95%99&oq=%E6%AD%A2%E7%97%9B%E8%97%A5+%E6%AE%98%E7%95%99&aqs=chrome..69i57.12264j0j2&sourceid=chrome&ie=UTF-8" target="_blank" rel="noopener noreferrer">
                <div className="google-hint">
                  <Octicon className="search" name="search" />
                  止痛藥殘留體內?
                </div>
              </a>
            </div>
            {
              this.props.isShow &&
              <YouTube
                videoId={video.youtubeID}                  // defaults -> null
                opts={{
                  width: size.width,
                  height: size.height,
                  playerVars: {
                    rel: 0,
                    showinfo: 0,
                    controls: 0,
                    modestbranding: 0,
                  },
                }}
                onEnd={this.handleHideLink}
                onPlay={() => send('Video', 'Play', `Btn_movie${videoIndex + 1}`)}
              />
            }
            {/* <iframe width={size.width} height={size.height} src={`https://www.youtube.com/embed/${video.youtubeID}?ecver=1&rel=0`} frameBorder="0" allowFullScreen /> */}
            <div onClick={() => this.handleClick(this.state.videoIndex - 1)} className="prev" rel="noopener noreferrer">
              <div className="text">上一篇</div>
            </div>
            <div onClick={() => this.handleClick(this.state.videoIndex + 1)} className="next" rel="noopener noreferrer">
              <div className="text">下一篇</div>
            </div>
            <div className="logo" />
            <h2 className="title">怪談<span>{video.id}</span></h2>
            <div className="story">{video.story}</div>
            <div className="description">{video.description}</div>
            { !video.hideLink && <div className="text-1">相信鬼話不如相信我的話</div> }
            { !video.hideLink && <div className="text-2">專業藥師</div> }
            { !video.hideLink && <div className="text-3">{video.dr}</div> }
            { videoIndex === 0 && <ManBlock /> }
            { videoIndex === 1 && <HandBlock /> }
            { videoIndex === 2 && <LineBlock /> }
          </div>
        </div>
        <a href="#sectionThree"  data-anchor="sectionThree">
          <Mouse down />
        </a>
        <a href="#sectionOne"  data-anchor="sectionOne">
          <div className="go-top" />
        </a>
      </div>
    );
  }
}


VideoBlock.propTypes = {
  isShow: PropTypes.bool,
};

VideoBlock.defaultProps = {
  isShow: false,
};

export default VideoBlock;



// WEBPACK FOOTER //
// ./src/blocks/VideoBlock/index.js